/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  has,
  isArray,
  isEmpty,
  isNull,
  isObject,
  isUndefined,
  toString,
  trim,
} from 'lodash';
import { AnalyticsProject } from '../../interfaces/analyticsProject';

/*
 * Private helper functions
 */

const buildTitle = (project: { name?: string; title?: string }) => {
  if (has(project, 'name')) {
    return trim(project.name);
  } else {
    // @ts-ignore
    return trim(project.title);
  }
};

const buildType = (types: string[]) =>
  isArray(types) ? types.join(',') : toString(types);

const getDeveloperName = (developer: { name: string } | string) =>
  isObject(developer) ? toString(developer.name) : toString(developer);

const build = (project: AnalyticsProject) => {
  project = project ?? ({} as AnalyticsProject);
  const { id, propertyType, developer, location, transportations, priceTypes } =
    project;

  let zoneLabel = '';
  let districtLabel = '';
  let roadLabel = '';
  if (!isEmpty(location)) {
    const {
      zone: zoneArray = [],
      district: districtArray = [],
      road: roadArray = [],
    } = location;

    const zoneParentArray = isArray(zoneArray)
      ? zoneArray.map((currentValue) => {
          return currentValue.parent;
        })
      : [];

    const zoneParentFiltered = isArray(zoneParentArray)
      ? zoneParentArray.filter((currentValue) => {
          return currentValue != null;
        })
      : [];

    const districtParentArray = isArray(districtArray)
      ? districtArray.map((currentValue) => {
          return currentValue.parent;
        })
      : [];

    const districtParentFiltered = isArray(districtParentArray)
      ? districtParentArray.filter((currentValue) => {
          return currentValue != null;
        })
      : [];

    const roadParentArray = isArray(roadArray)
      ? roadArray.map((currentValue) => {
          return currentValue.parent;
        })
      : [];

    const roadParentFiltered = isArray(roadParentArray)
      ? roadParentArray.filter((currentValue) => {
          return currentValue != null;
        })
      : [];

    if (zoneParentFiltered.length > 0 && !isNull(zoneParentFiltered[0])) {
      zoneLabel = zoneParentFiltered[0].label;
    } else if (isArray(zoneArray) && zoneArray.length > 0) {
      zoneLabel = zoneArray[0].label;
    }

    if (
      districtParentFiltered.length > 0 &&
      !isNull(districtParentFiltered[0])
    ) {
      districtLabel = districtParentFiltered[0].label;
    } else if (isArray(districtArray) && districtArray.length > 0) {
      districtLabel = districtArray[0].label;
    }

    if (roadParentFiltered.length > 0 && !isNull(roadParentFiltered[0])) {
      roadLabel = roadParentFiltered[0].label;
    } else if (isArray(roadArray) && roadArray.length > 0) {
      roadLabel = roadArray[0].label;
    }
  }

  let startingPrice = '';
  let levelLabel = '';
  if (!isEmpty(priceTypes) && !isUndefined(priceTypes)) {
    const {
      starting_price: starting,
      level = {} as {
        value: string;
        label: string;
      },
    } = priceTypes;
    startingPrice = starting;

    if (!isNull(level)) {
      const { label = '' } = level;
      levelLabel = label;
    }
  }

  let poiNameArray: string[] = [];
  let poiIdArray: string[] = [];
  if (isArray(transportations)) {
    poiNameArray = transportations.map((currentValue) => {
      return currentValue.label;
    });
    poiIdArray = transportations.map((currentValue) => {
      return currentValue.value;
    });
  }

  return {
    content: {
      project: {
        id: toString(id),
        name: buildTitle(project),
        propertyType: buildType(propertyType),
        developerName: getDeveloperName(developer),
        price: !isEmpty(startingPrice) ? startingPrice + ' million' : '',
        priceSegment: levelLabel,
        poiName: poiNameArray.toString(),
        poiId: poiIdArray.toString(),
        propertyLocationLevel1: zoneLabel,
        propertyLocationLevel2: districtLabel,
        propertyLocationLevel3: roadLabel,
      },
    },
  };
};

export default {
  build,
};
